import { Directive, Self, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { ActivityService } from '../../core';
import { SpinnerComponent } from './spinner.component';


@Directive({
  selector: '[igoSpinnerBinding]'
})
export class SpinnerBindingDirective implements OnInit, OnDestroy {

  private component: SpinnerComponent;
  private counter$$: Subscription;

  constructor(@Self() component: SpinnerComponent,
              private activityService: ActivityService) {
    this.component = component;
  }

  ngOnInit() {
    this.counter$$ = this.activityService.counter$
      .subscribe(count => this.component.shown = count > 0);
  }

  ngOnDestroy() {
    this.counter$$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/spinner/spinner-binding.directive.ts